const trimLeading = (str, char = '') => {
  if (!char) return str

  const regex = new RegExp(`^${char}+`)

  return str.replace(regex, '')
}

export default trimLeading
